import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { type AddCreditForm } from '../add-credit-form/add-credit-form-schema.ts';
import { VyRadioCardWrapper } from '../../../../../../components/new-design/inputs/VyRadioCard/VyRadioCardWrapper.tsx';
import { CREDIT_SCHEDULES, CreditSchedule } from '@vy/types';

const SCHEDULE_OPTIONS: readonly { value: CreditSchedule; label: string; dataVy: string }[] = [
  {
    value: CREDIT_SCHEDULES.RECURRING_MONTHLY,
    label: 'Monthly',
    dataVy: 'add-credit-drawer-schedule-monthly-card',
  },
  {
    value: CREDIT_SCHEDULES.RECURRING_QUARTERLY,
    label: 'Quarterly',
    dataVy: 'add-credit-drawer-schedule-quarterly-card',
  },
  {
    value: CREDIT_SCHEDULES.RECURRING_YEARLY,
    label: 'Yearly',
    dataVy: 'add-credit-drawer-schedule-yearly-card',
  },
];

export const ScheduleRadioCards: React.FC = () => {
  const { watch, setValue } = useFormContext<AddCreditForm>();
  const schedule = watch('schedule');

  const handleClick = (next: CreditSchedule) => {
    setValue('schedule', next, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <Stack direction="row" spacing={2}>
      {SCHEDULE_OPTIONS.map(({ value, label, dataVy }) => (
        <Box key={value} data-vy={dataVy} sx={{ flex: 1, display: 'flex' }}>
          <VyRadioCardWrapper
            onClick={() => handleClick(value)}
            isSelected={schedule === value}
            renderContent={(isSelected) => (
              <Typography
                sx={{ fontSize: '14px', textAlign: 'center', color: isSelected ? '#020F20' : '#5F6978' }}
              >
                {label}
              </Typography>
            )}
          />
        </Box>
      ))}
    </Stack>
  );
};
